import { render } from "./UnAuth.vue?vue&type=template&id=27c89e23"
const script = {}

import "./UnAuth.vue?vue&type=style&index=0&id=27c89e23&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__